import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { Suspense } from "react";
import Navbar from "./components/Navbar"; // Move Navbar here
import Footer from "./components/Footer"; // Move Footer here
import "./index.css";
import Home from "./pages/Home";
import ChipTuning from "./pages/ChipTuning";
import PopsBangs from "./pages/PopsBangs";
import DPFSolutions from "./pages/DPFSolutions";
import EGRSolutions from "./pages/EGRSolutions";
import NotFound from "./pages/NotFound";
import StartStop from "./pages/StartStop";
import ExhaustControl from "./pages/ExhaustControl";
import LaunchControl from "./pages/LaunchControl";
import HardRevCut from "./pages/HardRevCut";
import DTCRemoval from "./pages/DTCRemoval";
import DSGTuning from "./pages/DSGTuning";
import ECOTuning from "./pages/ECOTuning";
import AdblueSolutions from "./pages/AdblueSolutions";
import NOxSolutions from "./pages/NOxSolutions";
import Vmax from "./pages/Vmax";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import ContactUs from "./pages/ContactUs";
import WhatsappWidget from "./components/WhatsappWidget";
import TermsAndConditions from "./pages/TermsAndConditions";
import CarDetail from "./pages/cardetail/CarDetail";

function App() {
  return (
    <BrowserRouter>
      <Navbar /> {/* Navbar is now global and won't reload */}
      <Suspense>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/car-details" element={<CarDetail />} />
          <Route path="/services" element={<Services />} />
          <Route path="/chip-tuning" element={<ChipTuning />} />
          <Route path="/Pops-&-Bangs" element={<PopsBangs />} />
          <Route path="/DPF-Solutions" element={<DPFSolutions />} />
          <Route path="/EGR-Solutions" element={<EGRSolutions />} />
          <Route path="/Start-Stop" element={<StartStop />} />
          <Route path="/Exhaust-Flap-Control" element={<ExhaustControl />} />
          <Route path="/Launch-Control" element={<LaunchControl />} />
          <Route path="/Hard-Rev-Cut" element={<HardRevCut />} />
          <Route path="/DTC-Removal" element={<DTCRemoval />} />
          <Route path="/DSG-Tuning" element={<DSGTuning />} />
          <Route path="/ECO-Tuning" element={<ECOTuning />} />
          <Route path="/Adblue-Solutions" element={<AdblueSolutions />} />
          <Route
            path="/Lambdasonde-&-NOx-Solutions"
            element={<NOxSolutions />}
          />
          <Route path="/V-Max" element={<Vmax />} />
          <Route path="/Gallery" element={<Gallery />} />
          <Route path="/Contact-Us" element={<ContactUs />} />
          <Route
            path="/terms-and-conditions"
            element={<TermsAndConditions />}
          />

          <Route path="/*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <WhatsappWidget phoneNumber="31613100091" message="Hi, I need help!" />
      <Footer /> {/* Footer is now global and won't reload */}
    </BrowserRouter>
  );
}

export default App;
